import React from 'react';
import PropTypes from 'prop-types';
import css from './InfoCard.module.css';
import { ProductInfo } from '../ProductInfo';
import { NamedLink } from '../../../../components';
import { createSlug } from '../../../../util/urlHelpers';
import classNames from 'classnames';

function InfoCard({ item, removeItem, editAmount, intl, currentUser }) {
  const id = item.id.uuid;
  const { title = '' } = item.attributes;
  const slug = createSlug(title);
  const outOfStock = item.stock.attributes.quantity == 0;
  const imageClasses = outOfStock ? classNames(css.productImage, css.outOfStock) : css.productImage;

  return (
    <div className={css.cardContainer}>
      <NamedLink name="ListingPage" params={{ id, slug }}>
        <img
          src={item?.images[0]?.attributes.variants?.['square-small2x'].url}
          className={imageClasses}
        />
      </NamedLink>
      <ProductInfo
        removeItem={removeItem}
        editAmount={editAmount}
        item={item}
        intl={intl}
        currentUser={currentUser}
      />
    </div>
  );
}

InfoCard.propTypes = {
  product: PropTypes.object,
};

export default InfoCard;
